module.exports = __webpack_public_path__ + "static/img/20.9b9a207b.png";